import { render, staticRenderFns } from "./Preferencias.vue?vue&type=template&id=6f87644e&scoped=true&"
import script from "./Preferencias.vue?vue&type=script&lang=js&"
export * from "./Preferencias.vue?vue&type=script&lang=js&"
import style0 from "./Preferencias.vue?vue&type=style&index=0&id=6f87644e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87644e",
  null
  
)

export default component.exports